import Head from "next/head"

interface Props {
  schema: {
    "@context": string
    "@type": string
  } & Record<string, unknown>
  id: string // Id for script reasons. Auto postfixed with 'schema' to help avoid overlap
}

// Placing this in Head so it is included in view-source. Tried to use Next Script but no combination seemed to allow me to use it.
export const SchemaScript = ({ schema, id }: Props) => (
  <Head>
    <script
      key="structured-data"
      id={`${id.endsWith("-schema") ? id.replace("-schema", "") : id}-schema`}
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  </Head>
)
